import { useCallback, useEffect, useState } from "react";

import { UseTimerReturnType } from "./types";

const useTimer = (initTimeInSec = 60): UseTimerReturnType => {
  const [time, setTime] = useState(initTimeInSec);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime((prev) => {
        const newTime = prev - 1;

        if (newTime >= 0) {
          return newTime;
        }

        return prev;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [initTimeInSec]);

  const resetTimer = useCallback(() => {
    setTime(initTimeInSec);
  }, [initTimeInSec]);

  useEffect(() => {
    resetTimer();
  }, [resetTimer]);

  return {
    time,
    resetTimer,
  };
};

export default useTimer;
